import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import {EleccostEdit, Eleccost} from '../../../apis/urls'

const Editelecost = () => {

    const { id } = useParams();

    useEffect(() => {
        editelecost();
    },[]
    );

    const [res,setRes] = useState([]);
    const [table_num,setTable_num] = useState('');
    const [cost, setCost] = useState('');
    const [status, setStatus] = useState('');
    const [numerror,setnumerror] = useState(false);
    const [costerror,setcosterror] = useState(false);


    let navigate = useNavigate();
    const RoutToList = () =>{
        let path = 'newPath'; 
        navigate("/elecostlist")     
    }

    const editelecost = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance   = axios.create({
            baseURL: Eleccost+id,
            timeout: 1000000,
            headers: {'authorization': token}
            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            setTable_num(response.data.data.table_num);
            setCost(response.data.data.electricty_cost);
            setStatus(response.data.data.status);
 
            }).catch((error) =>{
            console.log('error',error.message)
            

            });
    }
    


    const onEditForm = () => {

        let error = 0;

        if(error === 0)
        {
            let token = "Bearer "+localStorage.getItem('token');
        
            const data = {
                table_num :table_num,
                cost :cost,
                status :status
            }
            
            const instance = axios.create({

                baseURL: EleccostEdit+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                
                
                navigate("/elecostlist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }

        
    }


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Electricity Cost</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>


                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/elecostlist">Electricity Cost</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit Electricity Cost</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div class="card formcard small">
                            <div class="card-body">
                                <div class="form-group">
                                    <label className="degreehead">Cost</label>
                                    <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setCost(e.target.value)}}  defaultValue={res.electricty_cost} id="desc"></input>
                                    {
                                       numerror
                                       ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The table Cost</div>
                                       :null
                                    }
                                </div>
                                <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                <div class="form-group text-right">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </form>






                </div>
            </aside>
        </div>

    )
}

export default Editelecost;
